export default class ActionCreator {
    constructor({ dispatcher }) {
        if (!dispatcher) {
            throw new Error('dispatcher must be provided');
        }

        this._dispatcher = dispatcher;
    }

    dispatch(payload) {
        this._dispatcher.dispatch(payload);
    }
}
